import React, { useState, useMemo, useEffect, useRef, ReactNode } from 'react';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import {
  errorModalTextRecoil,
  completeModalRecoil,
  modifyModalRecoil,
} from '@/atom/ModalAtom';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import LS from '@/styles/layoutStyled';
import CS from '@/styles/componentStyled';
import BS from '@/styles/btnStyled';
import IS from '@/styles/inputStyled';
import { ApiService } from '@/api';
import { TokenDto, LoginDto } from '@/model/user.dto';

const Login = () => {
  const api = useMemo(() => new ApiService(), []);
  const navigate = useNavigate();
  const setErrorModalText = useSetRecoilState(errorModalTextRecoil);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleLogin = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (email.trim() === '' || password.trim() === '') {
      setErrorModalText('아이디 비밀번호를 입력해 주세요.');
      return;
    }

    const dto: LoginDto = {
      email,
      password,
    };

    const token = await api.postLogin(dto);

    if (!token) {
      setErrorModalText('아이디 비밀번호를 확인해 주세요.');
      return;
    }

    sessionStorage.setItem('accessToken', token.accessToken);
    sessionStorage.setItem('refreshToken', token.refreshToken);
    sessionStorage.setItem('activeIndex', '0');
    navigate('/dashboard');
  };

  useEffect(() => {
    const token = sessionStorage.getItem('accessToken');
    if (token) {
      navigate('/dashboard');
    }
  }, []);

  return (
    <>
      <Wrap className="flex aic jcc">
        <div className="log-box flex">
          <div className="img-area"></div>
          <div className="field-box flex fdc aic jcc">
            <span className="logo-box img-box">
              <img src="./img/logo.svg" alt="" />
            </span>
            <form onSubmit={handleLogin} className="w100per">
              <div className="input-wrap flex fdc">
                <div className="input-box rel">
                  <input
                    type="text"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <span className="text abs">아이디</span>
                </div>
                <div className="input-box rel">
                  <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <span className="text abs">비밀번호</span>
                </div>
              </div>
              <button className="log-btn flex aic jcc tm" type="submit">
                로그인
              </button>
            </form>
          </div>
        </div>
      </Wrap>
    </>
  );
};

export default Login;

export const Wrap = styled.div`
  width: 100%;
  height: 100vh;
  background: #f1f1f1;
  .log-box {
    width: 992px;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.1);
    .img-area {
      width: 50%;
      background: url('/img/log_bg.jpg') no-repeat center center/cover;
    }
    .field-box {
      width: 50%;
      box-sizing: border-box;
      padding: 120px 48px;
      background: #fff;
      .logo-box {
        width: 160px;
      }
      .input-wrap {
        width: 100%;
        margin-top: 50px;
        .input-box {
          width: 100%;
          &:first-child {
            > input {
              border-radius: 6px 6px 0 0;
            }
          }
          &:last-child {
            > input {
              border-radius: 0 0 6px 6px;
              border-top: none;
            }
          }
          > input {
            width: 100%;
            box-sizing: border-box;
            padding: 30px 20px 18px 20px;
            border: 1px solid #ececec;
            font-size: 20px;
            color: #333;
          }
          .text {
            letter-spacing: -0.05em;
            font-size: 12px;
            color: #999;
            opacity: 0.8;
            top: 14px;
            left: 20px;
          }
        }
      }
      .log-btn {
        margin-top: 24px;
        width: 100%;
        height: 56px;
        font-size: 20px;
        letter-spacing: -0.05em;
        background-color: ${(props) => props.theme.mainColor1};
        color: #fff;
        border-radius: 6px;
      }
    }
  }
`;
